<!--
  - Copyright (c) 2020 GanttProject Cloud OU
  -->

<template>
    <div>
        <div class="d-flex align-items-center">
            <h5 class="m-0">{{ candidate.name }}</h5>
            <span class="ml-2 badge badge-pill badge-secondary">Candidate</span>
            <div class="flex-fill"></div>
            <button class="btn btn-outline-secondary btn-icon btn-menu"
                    v-on:click="invite"
                    data-toggle="modal"
                    data-target="#modal-new-invite"
                    title="Invite">
                <i class="fas fa-user-plus"></i></button>
        </div>
        <small class="text-muted">{{ candidate.email }}</small>
    </div>
</template>

<script lang="ts">
  import {Prop, Component, Vue} from 'vue-facing-decorator';
  import {ResourceDto, TeamDto} from '../Teams';

  @Component
  export default class CandidateItem extends Vue {
    @Prop()
    public candidate: ResourceDto;

    @Prop()
    public team: TeamDto;

    public invite() {
      this.$emit('invite')
    }
  }
</script>
